import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#464646",
      stroke: "#464646",
      "stroke-width": ".5",
      d: "M10 11.615a.62.62 0 0 0-.187-.449L4.334 5.822v.85l5.479-5.338A.6.6 0 0 0 10 .885.62.62 0 0 0 9.37.25a.65.65 0 0 0-.457.186L3.42 5.787a.65.65 0 0 0-.201.463c0 .18.076.331.208.463l5.486 5.344c.124.13.27.193.45.193.36 0 .637-.276.637-.635Zm-6.76.034V.865c0-.36-.256-.615-.624-.615A.59.59 0 0 0 2 .865v10.784c0 .352.256.601.616.601.368 0 .624-.249.624-.6Z"
    }, null, -1)
  ])))
}
export default { render: render }